export default __webpack_public_path__ + "static/media/info.809fdeb1.svg";